import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
@Component({ standalone: true, imports: [RouterLink], templateUrl: './public-consultations.component.html', styleUrl: './public-consultations.component.css' })
export class PublicConsultationsComponent {}
